import { EEmisniPodminky } from 'enums/isin/udaje/emisniPodminky';

export const emisniPodminkySelectUmoznuje = [
    {
        value: EEmisniPodminky.NE,
        labelcz: 'ISIN_EMISE_DLUHOPIS_EMIS_PODM_F'
    },
    {
        value: EEmisniPodminky.UMED,
        labelcz: 'ISIN_EMISE_DLUHOPIS_EMIS_PODM_G'
    },
    {
        value: EEmisniPodminky.UMDD,
        labelcz: 'ISIN_EMISE_DLUHOPIS_EMIS_PODM_C'
    },
    {
        value: EEmisniPodminky.UMPS,
        labelcz: 'ISIN_EMISE_DLUHOPIS_EMIS_PODM_D'
    },
    {
        value: EEmisniPodminky.UPSUMJ,
        labelcz: 'ISIN_EMISE_DLUHOPIS_EMIS_PODM_A'
    },
    {
        value: EEmisniPodminky.UPEMPO,
        labelcz: 'ISIN_EMISE_DLUHOPIS_EMIS_PODM_B'
    },
    {
        value: EEmisniPodminky.UPDMPO,
        labelcz: 'ISIN_EMISE_DLUHOPIS_EMIS_PODM_T'
    },
    {
        value: EEmisniPodminky.UPEDPO,
        labelcz: 'ISIN_EMISE_DLUHOPIS_EMIS_PODM_L'
    },
    {
        value: EEmisniPodminky.UMP,
        labelcz: 'ISIN_EMISE_DLUHOPIS_EMIS_PODM_E'
    }
];
export const emisniPodminkySelectNeumoznuje = [
    {
        value: EEmisniPodminky.NOSV,
        labelcz: 'ISIN_EMISE_DLUHOPIS_EMIS_PODM_P'
    },
    {
        value: EEmisniPodminky.NOSVE,
        labelcz: 'ISIN_EMISE_DLUHOPIS_EMIS_PODM_Q'
    },
    {
        value: EEmisniPodminky.NODSVD,
        labelcz: 'ISIN_EMISE_DLUHOPIS_EMIS_PODM_R'
    }
];
